module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "modal",
    attrs: {
      "centered": "",
      "visible": "",
      "size": "lg",
      "content-class": "dropshipment-products-modal",
      "hide-footer": true,
      "title": "Product overzicht"
    },
    on: {
      "hidden": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_c('div', [_c('api-table-block', {
    ref: "productsTable",
    attrs: {
      "fields": _vm.fields,
      "items": _vm.findAllProducts,
      "default-sort-by": "created_at",
      "item-label-singular": "product",
      "item-label-plural": "producten"
    },
    scopedSlots: _vm._u([{
      key: "name",
      fn: function(data) {
        return [_c('a', {
          attrs: {
            "href": "#"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              _vm.details(data.item)
            }
          }
        }, [_vm._v(_vm._s(data.value))])]
      }
    }, {
      key: "price",
      fn: function(data) {
        return [(data.item.sale_price) ? _c('sale-price-editable', {
          key: data.item.id,
          attrs: {
            "price": data.item.price,
            "sale_price": data.item.sale_price,
            "product-id": data.item.id
          }
        }) : _c('price-editable', {
          key: data.item.id,
          attrs: {
            "price": data.item.price,
            "product-id": data.item.id
          }
        })]
      }
    }, {
      key: "stock_quantity",
      fn: function(data) {
        return [_c('stock-editable', {
          key: data.item.id,
          attrs: {
            "quantity": data.value,
            "product-id": data.item.id
          }
        })]
      }
    }, {
      key: "location",
      fn: function(data) {
        return [_c('div', [_c('location-editable', {
          key: data.item.id,
          attrs: {
            "field": "location",
            "value": data.item.location,
            "product-id": data.item.id
          }
        })], 1), _vm._v(" "), _c('div', [_c('small', [_vm._v("\n               Rest:\n               "), _c('field-editable', {
          key: data.item.id,
          attrs: {
            "field": "overstock_location",
            "value": data.item.overstock_location,
            "product-id": data.item.id
          }
        })], 1)])]
      }
    }])
  }), _vm._v(" "), (_vm.detailModalProductId) ? _c('product-detail-modal', {
    key: _vm.detailModalProductId,
    attrs: {
      "product-id": _vm.detailModalProductId
    },
    on: {
      "close": function($event) {
        _vm.detailModalProductId = null
      },
      "remove": _vm.refresh
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30665345","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/dropshipment/DropshipmentProductsTable.vue
// module id = 701
// module chunks = 1